import { render, staticRenderFns } from "./FirstLogin3.vue?vue&type=template&id=f4b28ca8&scoped=true"
import script from "./FirstLogin3.vue?vue&type=script&lang=js"
export * from "./FirstLogin3.vue?vue&type=script&lang=js"
import style0 from "./FirstLogin3.vue?vue&type=style&index=0&id=f4b28ca8&prod&lang=scss&scoped=true"
import style1 from "./FirstLogin3.vue?vue&type=style&index=1&id=f4b28ca8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b28ca8",
  null
  
)

export default component.exports